import request from '../../../axios';

const getLikedPosts = async () => {
  const {data}: {data: Array<IUserListLikedData>} = await request.get(
    '/api/v2/store/liked-posts-list',
  );
  return data;
};

export default getLikedPosts;
